import React from 'react';
import maintenanceImage from '../../assets/Maintance.png';

const MaintenancePage = () => {
  return (
    <div 
      className="min-h-screen w-full"
      style={{
        backgroundImage: `url(${maintenanceImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center'
      }}
    />
  );
};

export default MaintenancePage;